export type ShippingOption = {
  key: string
  carrier: string
  label: string
  price: number
  description: string
  link: string
}

export const SHIPPING_OPTIONS: ShippingOption[] = [
  {
    key: 'posten_liten',
    carrier: 'Posten',
    label: 'Norgespakke™ liten',
    price: 76,
    description: '≤5 kg · 35×25×12 cm',
    link: 'https://www.posten.no/sende/i-norge/norgespakke',
  },
  {
    key: 'posten_stor',
    carrier: 'Posten',
    label: 'Norgespakke™ stor',
    price: 140,
    description: '≤35 kg · 120×60×60 cm',
    link: 'https://www.posten.no/sende/i-norge/norgespakke',
  },
  {
    key: 'posten_ekspress',
    carrier: 'Posten',
    label: 'Norgespakke™ ekspress',
    price: 691,
    description: '≤35 kg · neste dag',
    link: 'https://www.posten.no/sende/i-norge/norgespakke',
  },
  {
    key: 'postnord_small',
    carrier: 'PostNord',
    label: 'MyPack Home small',
    price: 69,
    description: '≤5 kg · 60×40×20 cm',
    link: 'https://www.postnord.no/tjenester-privat/prisliste-privatkunder/',
  },
  {
    key: 'postnord_large_10',
    carrier: 'PostNord',
    label: 'MyPack Home large 10 kg',
    price: 129,
    description: '≤10 kg · 120×60×60 cm',
    link: 'https://www.postnord.no/tjenester-privat/prisliste-privatkunder/',
  },
  {
    key: 'postnord_large_20',
    carrier: 'PostNord',
    label: 'MyPack Home large 20 kg',
    price: 229,
    description: '≤20 kg · 120×60×60 cm',
    link: 'https://www.postnord.no/tjenester-privat/prisliste-privatkunder/',
  },
  {
    key: 'postnord_large_35',
    carrier: 'PostNord',
    label: 'MyPack Home large 35 kg',
    price: 309,
    description: '≤35 kg · 120×60×60 cm',
    link: 'https://www.postnord.no/tjenester-privat/prisliste-privatkunder/',
  },
]

export function findShippingOption(key: string | null): ShippingOption | undefined {
  return SHIPPING_OPTIONS.find(o => o.key === key)
}
